














































  // @click:row="handleClick"
  import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
  import kepler from "../../../lib/kepler_sdk/kepler";
  import TableCell from "@/views/UI/TableCell.vue";
  // import SmartForm from "@/views/UI/SmartForm.vue";
  import SmartForm from "../../../lib/smart-form/SmartForm.vue"
  import schemaHelper from "../../../lib/kepler_sdk/schemaHelper";
  import {copy, transform} from "../../../lib/utils";
  import notifications from "../../../lib/notifications";

  @Component({
    components: {SmartForm, TableCell},
  })


  export default class Table extends Vue {
    @Prop() public endpoint!: string;
    @Prop() public detail!: string;
    @Prop() public schemaName!: string;
    @Prop() public headers!: any;
    @Prop({}) public transforms!: any;
    @Prop({default: true}) public withPagination!: boolean;
    @Prop({default: null}) public staticData!: any;
    @Prop({default: false}) public parentLoading!: boolean;
    @Prop({default: true}) public withAddButton!: boolean;

    @Prop({default: true}) public actionDelete!: boolean;
    @Prop({default: true}) public actionUpdate!: boolean;

    @Prop() public tabId!: any;

    public loading = true;
    public totalItems = null;
    public items: any[] = []
    public totalPages = null;

    public options = {page: 1, itemsPerPage: 20};
    public dialog = false;
    public saveDisable = false;

    public mounted() {
     // this.dataLoad()

    }

    // SmartForm START
    public model: any = {}
    public schema: any = {}

    public formMode: string = ""

    public openNewForm(mode: string, item: any) {
      // Export the operation
      this.dialog = false;
      this.formMode = mode
      this.schema = {}
      this.model = {}

      // Set the schema and transform it if necessary
      if (this.schemaName) {
        this.schema = schemaHelper(this.schemaName)
      }

      let trans = false
      if (this.transforms) {
        trans = this.transforms[mode] || this.transforms['_']
      }

      if (trans) {
        this.schema = transform(this.schema, trans)
      } else {
        console.warn("NO MODE", mode)
      }


      if (mode === 'copy' || mode === 'edit') {
        console.log("item => " + JSON.stringify(item))
        this.model = copy(item)
        if (trans) {
          this.model = transform(this.model, trans)
        }
      }

      this.$nextTick(() => {
        this.dialog = true;
      })
    }

    // Form output

    public closeForm() {
      // alert(JSON.stringify(this.model, null, 2))
      this.dialog = false;
    }

    // NEW
    public saveForm() {
      this.doIfIsTransform('beforeSave')

      kepler.post(this.schemaName, this.model)!.then(() => {
        notifications.notify("success", "ITEM CREATED")
        this.closeForm()
        this.dataLoad()
      }).catch(this.notifyError)
    }

    // PATCH
    public editItem() {

      this.doIfIsTransform('beforeUpdate')

      kepler.update(this.schemaName, this.model.id, this.model)!.then(() => {
        notifications.notify("success", "ITEM EDITED")
        this.closeForm()
        this.dataLoad()
      }).catch(this.notifyError)
    }

    // DELETE
    public deleteItem(item: any) {
      if (confirm('Are you sure? Delete: ' + item.id)) {
        kepler.delete(this.schemaName, item.id)!.then(() => {
          notifications.notify("success", "ITEM DELETED")
          this.dataLoad()
        }).catch(this.notifyError)
      }
    }

    public notifyError(error: any) {
      notifications.notify("error", error.response.status + ": " + JSON.stringify(error.response.data, null, 2))
    }

    get headersWithSlotName() {
      return this.headers.map((i: any) => {
        i.slotName = 'item.' + i.value
        return i
      })
    }

    public handleClick(item: any) {
      if (this.detail)
        this.$router.push({name: this.detail, params: {id: item.id}})
    }

    public doIfIsTransform(mode:string) {
      let trans = false
      if (this.transforms) {
        trans = this.transforms[mode]
      }

      if(trans) {
        this.model = transform(this.model, trans)
      }

    }

   
    // Download data from the api and set correct headers
    @Watch('options', {deep: true})
    @Watch('$route')
    @Watch('staticData')
    private dataLoad(x:any = null) {
      if (this.staticData != null) {
        this.totalItems = this.staticData.length;
        this.loading = false

        this.items = this.staticData
        return
      }
      this.loading = true

      kepler.get(this.endpoint, this.options)!.then((d) => {
        notifications.notify("success", this.schemaName + " TABLE LOADED")
        this.totalItems = d.data.items_count
        this.totalPages = d.data.page_count
// to do portare fuori la chiave che contiene l'array di oggetti restituiti dall'endpoint a meno di non avere uniformità dei dati restituiti da tutti gli endpoint
        if (Array.isArray(d.data.items)) {
          this.items = d.data.items
        }
        if (Array.isArray(d.data.clientTypes)) {
          this.items = d.data.clientTypes
        }

        if (Array.isArray(d.data)) {
          this.items = d.data
        }

        if (this.headers.length === 0 && this.items.length > 0) {
          this.headers = Object.keys(this.items[0])
        }
        this.loading = false
      })
    }

  }
